import { render } from "./RatingVotes.vue?vue&type=template&id=1f2ad1db"
import script from "./RatingVotes.vue?vue&type=script&lang=js"
export * from "./RatingVotes.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__